export const reservasModals = {
  roomChange: {
    close: "Fermer",
    titleAssign: "Attribuer une chambre",
    titleChange: "Changer de chambre",
    stopSoldNote:
      "Ce type de chambre est fermé à la vente à ces dates (stop-sell), mais vous pouvez toujours réorganiser les chambres : déplacer ou attribuer ne rouvrira pas les ventes.",
    labelAssign: "Chambre à attribuer",
    labelNew: "Nouvelle chambre",
    selectPlaceholder: "Sélectionner une chambre…",
    swapWith: "Échanger avec {names}",
    swapWithType: "Échanger avec {names} (passe en {type})",
    swapTypeWarning: "Après l'échange, {names} passe en {type}, qui n'est pas le type réservé.",
    swapGroup:
      "Échange groupé : {name} et {also} sont déplacés vers cette chambre, et {incoming} sont déplacés vers la vôtre. Le tout en une seule opération.",
    swapSingle:
      "Cette chambre est occupée par {names}. À l'enregistrement, ils seront {action} : votre réservation est déplacée vers cette chambre et l'autre (ou les autres) vers la vôtre.",
    swapWord: "échangés",
    emptyNote:
      "Aucune chambre n'est libre pour toute la période. Utilisez le bouton {action} de la file « À organiser » pour réorganiser automatiquement les réservations.",
    organizeWord: "Organiser",
    sameTypeGroup: "Même type · {name}",
    otherTypeGroup: "Autre type · {name}",
    typeChangeNote:
      "La réservation passera en {type}. Sa fiche est mise à jour, la disponibilité des deux types est recalculée et les canaux sont prévenus.",
    selectRoomError: "Vous devez sélectionner une chambre",
    cancel: "Annuler",
    confirmSwap: "Échanger",
    confirmAssign: "Attribuer",
    confirmSave: "Enregistrer la modification",
  },
  outOfOrder: {
    titleMaintenance: "Maintenance de la chambre",
    titleActions: "Actions sur le type de chambre",
    scopeLabel: "Portée",
    scopeUnit: "Type de chambre (tous)",
    scopeInstance: "Cette chambre",
    actionLabel: "Action",
    actionOoo: "Hors service (maintenance)",
    actionOpen: "Rouvrir sur la période",
    quantityLabel: "Nombre de chambres",
    maxPerDay: "Jusqu'à {max} par jour.",
    dateRangeLabel: "Plage de dates",
    from: "Du",
    to: "Au",
    cancel: "Annuler",
    apply: "Appliquer",
  },
  closeDay: {
    title: "Modifier la disponibilité",
    syncing: "Synchronisation de la disponibilité...",
    roomTypeLabel: "Type de chambre",
    roomTypePlaceholder: "Sélectionner une chambre",
    startDate: "Date de début",
    endDate: "Date de fin",
    maxAvailable: "Maximum : {count} disponible(s)",
    cancel: "Annuler",
    apply: "Appliquer la modification",
  },
  confirm: {
    defaultTitle: "Confirmer ?",
    confirm: "Confirmer",
    cancel: "Annuler",
  },
  updateAlert: {
    title: "Mettre à jour la chambre",
    sectionTitle: "Informations sur la chambre",
    nameLabel: "Nom ou numéro de la chambre",
    keyLabel: "Clé d'accès",
    cancel: "Annuler",
    submit: "Mettre à jour la chambre",
    nameRequired: "Le nom ou le numéro de la chambre est obligatoire",
  },
};
